<div class="page-holding"></div>

<div class="about-page">
  <section class="about-hero">
    <div class="about-hero__eyebrow">About Huahan</div>
    <h1>我们专注于工业打印软件与流程协同体验</h1>
    <p>
      华瀚持续围绕 RIP、智能排版、文档编辑和自动化流程构建产品能力，
      让软件不只是一个工具点，而是成为企业生产链路中稳定、可靠、可持续扩展的一部分。
    </p>

    <div class="about-hero__stats">
      <article>
        <strong>3+</strong>
        <span>核心产品方向</span>
      </article>
      <article>
        <strong>B2B</strong>
        <span>企业服务导向</span>
      </article>
      <article>
        <strong>长期</strong>
        <span>产品迭代与支持</span>
      </article>
    </div>
  </section>

  <section class="about-section about-section--intro">
    <div class="section-heading">
      <span>我们是谁</span>
      <h2>从软件能力到业务落地，尽量让每一步都更清晰</h2>
      <p>
        我们相信真正有价值的软件，不只是功能齐全，而是能融入客户的实际生产环境，
        在效率、稳定性、协作方式和后续维护上都体现出明确收益。
      </p>
    </div>

    <div class="intro-layout">
      <div class="intro-copy">
        <p>
          华瀚面向工业打印及相关数字化生产场景，持续构建专业软件产品。
          我们关注的不只是前端界面是否易用，更包括流程衔接、输出一致性、部署适配和长期可维护性。
        </p>
        <p>
          因此，在产品设计上，我们尽量让网站咨询、试用申请、功能理解和后续接入形成一条顺畅的体验链路，
          减少客户从认知到落地之间的摩擦。
        </p>
      </div>

      <div class="intro-panel">
        <p class="intro-panel__title">核心能力覆盖</p>
        <ul>
          <li *ngFor="let item of capabilities">{{ item }}</li>
        </ul>
      </div>
    </div>
  </section>

  <section class="about-section">
    <div class="section-heading">
      <span>我们的价值观</span>
      <h2>更重视能否真正帮助客户解决问题</h2>
    </div>

    <div class="value-grid">
      <article class="value-card" *ngFor="let item of values">
        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p>
      </article>
    </div>
  </section>

  <section class="about-section about-section--timeline">
    <div class="section-heading">
      <span>发展方式</span>
      <h2>沿着“产品能力 + 服务能力”双线推进</h2>
    </div>

    <div class="timeline">
      <article class="timeline-card" *ngFor="let item of milestones">
        <p class="timeline-card__label">{{ item.year }}</p>
        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p>
      </article>
    </div>
  </section>

  <section class="about-cta">
    <div>
      <span>持续合作</span>
      <h2>如果你正在评估打印软件流程，欢迎直接联系我们</h2>
      <p>我们更愿意以真实场景沟通需求，再判断最合适的产品与接入方式。</p>
    </div>
    <div class="about-cta__actions">
      <a routerLink="/contact" class="primary-link">联系我们</a>
      <a routerLink="/price" class="secondary-link">查看定价</a>
    </div>
  </section>
</div>
